import { doc, getDoc, updateDoc } from "@firebase/firestore";
import { hideLoading, setItemPhotosList, showLoading } from "./item-photos-list-slice"
import { showErrorSnackbar, showWarningSnackbar } from "../../../../../../../shared/snackbar/snackbar-slice";


export const getItemPhotosService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const item_data = docSnap.data();
            if(Boolean(item_data?.image_url) === true) {
                dispatch(setItemPhotosList(item_data.image_url));
            }
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
          dispatch(showErrorSnackbar('Fetch failed! Please try again.'));
          console.error("ItemPhotosList getItemPhotosService error: ", e);
    }
    dispatch(hideLoading());
};

export const setItemThumbnail = async (dispatch, db, coll, id, formData) => {
    try {
        await updateDoc(doc(db, coll, id), formData);
    } catch(e) {
          dispatch(showErrorSnackbar('Update failed! Please try again.'));
          console.error("ItemPhotosList setItemThumbnail error: ", e);
    }
};